import { withLoader } from 'util/routeHelper';

export default store => ({
	path: 'service',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'service',
				),
			store,
			'SERVICE',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/Service/index.js